import { render } from "./QuestionBank.vue?vue&type=template&id=ee8cb226&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"

import "./QuestionBank.vue?vue&type=style&index=0&id=ee8cb226&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8cb226"]])

export default __exports__